import { createContext, useCallback, useContext, useState } from "react";

const VideoModalContext = createContext({ isOpen: false, open: () => {}, close: () => {} });

export function VideoModalProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    return (
        <VideoModalContext.Provider value={{ isOpen, open, close }}>
            {children}
        </VideoModalContext.Provider>
    );
}

export function useVideoModal() { return useContext(VideoModalContext); }
